import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  title: {
    color: theme.colors.midnightBlue[0],
  },
}));
